import React, { useContext } from 'react';
import {IProps} from './types';
import * as S from './styles';
import PositionCommandOption from './CommandsOptions/PositionCommandOption';
import UndoCommandOption from './CommandsOptions/UndoCommandOption';
import RedoCommandOption from './CommandsOptions/RedoCommandOption';
import CopyPasteCommandOption from './CommandsOptions/CopyPasteCommandOption';
import DeleteCommandOption from './CommandsOptions/DeleteCommandOption';
import OpacityCommandOption from './CommandsOptions/OpacityCommandOption';
import SaveStatus from './CommandsOptions/SaveStatus';
import SwitchSelectDescribe from './CommandsOptions/SwitchSelectDescribe';
import UserPreferences from './CommandsOptions/UserPreferences';
import LockUnlockCommandOption from './CommandsOptions/LockUnlockCommandOption';
import { Context } from "routes/private/Editor/Context";
import { isLockedElement } from '@utils/editor'

const MainCommandBar:React.FC<IProps> = (props) => {
  const { entityInformation, editorStatus, data } = useContext(Context);
  const isLocked = isLockedElement(editorStatus.selectedElementsId, data);

  return (
    <S.Root>
      <SaveStatus/>
      <S.Line/>
      { editorStatus.selectedElementsId && editorStatus.selectedElementsId.length > 0 && !isLocked ?
        <>
          <CopyPasteCommandOption/>
          <S.Line/>
          <OpacityCommandOption/>
          <S.Line/>
        </>
        :editorStatus.selectedArtboardIds && editorStatus.selectedArtboardIds.length===1 && !isLocked ?
        <>
        <CopyPasteCommandOption/>
        </>
        :
        <></>
      }  
      <UndoCommandOption/>
      <RedoCommandOption/>
      <S.Line/>
      { editorStatus.selectedElementsId && editorStatus.selectedElementsId.length > 0 && !isLocked ?
        <>
          <PositionCommandOption/>
          <S.Line/>
          <DeleteCommandOption/>
          <S.Line/>
          <LockUnlockCommandOption/>
          <S.Line/>
        </>
        :
        editorStatus.selectedElementsId && editorStatus.selectedElementsId.length > 0 && <LockUnlockCommandOption/>
      }  

      { (editorStatus.selectedElementsId.length === 0 && editorStatus.selectedArtboardIds && editorStatus.selectedArtboardIds.length === 1 && data[0]?.children && data[0].children.length > 1) &&
        <>
          <DeleteCommandOption/>
          <S.Line/>
        </>
      }  
      {entityInformation?.entityType === "TEMPLATE" &&
        <>
        <SwitchSelectDescribe style={{marginLeft: "20px"}}/>
      </>}
      <UserPreferences/>
    </S.Root>
  );
}

export default MainCommandBar;